/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/attachment_medium'
export default icon
